import 'mediaelement/full';

export const Video = class Video {
    constructor() {
        this.ua = navigator.userAgent.toLowerCase();
    }

    init() {

        this.popupVideo();

    }

    popupVideo() {
        const self = this;

        $('.js-video__wrapper').each(function() {
            // popup video
            const playBtn = $(this).find('.js-video__play'),
                videoPopup = $(playBtn.attr('data-target')),
                videoPopupClose = videoPopup.find('.js-video-popup__close');

            var videoInPopup = videoPopup.find('video').mediaelementplayer({
                pluginPath: "/path/to/shims/",
                success: function(mediaElement, originalNode, instance) {}

            });
            console.log(videoPopup);
            // console.log(videoInPopup[0]);

            playBtn.on('click touchstart', (ev) => {
                ev.preventDefault();
                videoPopup.aClass('', 'is-visible');
                // console.log(videoInPopup);
                // console.log(videoInPopup[0].player);

                videoInPopup[0].player.play();

                $('body').aClass('', 'noscroll');
            });

            videoPopupClose.on('click touchstart', (ev) => {
                ev.preventDefault();

                videoInPopup[0].player.pause();

                $('body').aClass('noscroll', '');
                videoPopup.aClass('is-visible', '');
            });

        });

    }
};


// WEBPACK FOOTER //
// ./static/js/components/Video.js